import { getMountainTime } from "./time";

export const routeToServerlessAPI = (error) => {
    //Route the request to the serverless API
    if (
        error &&
        error.name === 'AxiosError' &&
        (
            error.message === 'Network Error' ||
            (error.response && error.response.status === 503)
        )
    ) {
        return true;
    } else if (!error) {
        const mountainTime = getMountainTime(new Date());
        if (mountainTime.mountainTimeHours < 6 || mountainTime.mountainTimeHours >= 14) {
            return true;
        }
    }
    return false;
}